module.exports = __webpack_public_path__ + "img/22bf87bf65924d2ca7841d175a4d6bfd-1440.7653248a.jpg";